// Mock data for Securelec Homepage

export const businessInfo = {
  name: "Securelec Services",
  tagline: "Reliable Security and Electrical solutions for your home and business.",
  phone: {
    mick: "+61 413 104 012",
    tom: "+61 423 746 855"
  },
  email: "hello@securelec.net.au",
  licenses: {
    electrical: "REC 30321",
    security: "853-441-92S"
  },
  instagram: "@securelec_",
  instagramUrl: "https://www.instagram.com/securelec_",
  quoteUrl: "https://sm8.link/2ppstr9"
};

export const heroContent = {
  headline: "Your Trusted Electrician in",
  subheadline: "Carrum & Bayside Melbourne",
  description: "Residential & commercial solutions across Melbourne & Victoria. Dual-owner expertise delivering end-to-end electrical and security services.",
  badge: "30+ Years Combined Experience",
  ctaPrimary: "Get a Quote",
  ctaSecondary: "Call Now"
};

export const whyChooseUs = [
  {
    id: 1,
    icon: "Users",
    title: "Owners On The Tools",
    description: "Deal directly with Michael & Tom, our expert owners who personally handle your projects."
  },
  {
    id: 2,
    icon: "Shield",
    title: "End-to-End Solutions",
    description: "Complete electrical and security services under one roof – no need for multiple contractors."
  },
  {
    id: 3,
    icon: "Clock",
    title: "Fast & Reliable",
    description: "Quick response times with consistent, dependable service you can count on."
  },
  {
    id: 4,
    icon: "Award",
    title: "Licensed & Certified",
    description: "Fully licensed electrical and security specialists with all necessary certifications."
  },
  {
    id: 5,
    icon: "Handshake",
    title: "Long-Term Relationships",
    description: "We build lasting partnerships with our clients, not just one-time transactions."
  },
  {
    id: 6,
    icon: "Zap",
    title: "Specialist Capability",
    description: "Advanced expertise in access control, fibre, lighting automation, and more."
  }
];

export const aboutContent = {
  title: "Who We Are",
  description: "Securelec is a proudly Australian-owned and operated business, dedicated to providing reliable service from start to finish. We understand that the Electrical and Security industries are always changing, and we strive to adapt and grow with these changes.",
  extendedDescription: "At Securelec, we value collaboration and reliability. We listen to our clients' needs and help them understand their options, ensuring they feel confident in their decisions. No problem is too big or too small for us to handle with care and expertise.",
  owners: [
    {
      name: "Michael",
      role: "Security Specialist",
      expertise: "30+ years in security systems, access control, and CCTV installations"
    },
    {
      name: "Tom",
      role: "Electrical Expert",
      expertise: "Specialist in commercial switchboards, lighting control, and electrical infrastructure"
    }
  ]
};

export const clientLogos = [
  { id: 1, name: "Client 1", placeholder: true },
  { id: 2, name: "Client 2", placeholder: true },
  { id: 3, name: "Client 3", placeholder: true },
  { id: 4, name: "Client 4", placeholder: true },
  { id: 5, name: "Client 5", placeholder: true },
  { id: 6, name: "Client 6", placeholder: true }
];

export const services = [
  {
    id: 1,
    category: "Security",
    icon: "Shield",
    description: "Security systems designed, installed and maintained for homes and businesses.",
    services: ["CCTV", "Alarm Systems", "Access Control", "Intercom Systems", "Home Automation", "Data & Communication", "Driveway Bollards"],
    href: "/what-we-do/security"
  },
  {
    id: 2,
    category: "Electrical",
    icon: "Zap",
    description: "Residential and commercial electrical work delivered by a team you can trust.",
    services: ["EV Chargers", "Light and Power", "Switchboard Upgrades", "Medical & Dental Practices", "Home Automation"],
    href: "/what-we-do/electrical"
  }
];

export const googleReviews = [
  {
    id: 1,
    author: "Sh S",
    rating: 5,
    text: "Tom was fantastic \u2013 very professional and right on time. He did an excellent job and we\u2019re so happy with his work. Highly recommend!"
  },
  {
    id: 2,
    author: "Yanni Mougos",
    rating: 5,
    text: "Michael and the team are quality professionals. They did a fantastic job and left the place in great condition. Highly recommend."
  },
  {
    id: 3,
    author: "The Salters",
    rating: 5,
    text: "We recently used Securelec for a challenging electrical job which they handled flawlessly. The team were very knowledgeable and professional. Highly recommended."
  },
  {
    id: 4,
    author: "T Ian",
    rating: 5,
    text: "Michael installed lighting and a fan for my pergola. If you\u2019re looking for someone who is professional, knowledgeable, punctual and tidy, then look no further than Michael from Securelec. Extremely happy with the result."
  },
  {
    id: 5,
    author: "Jemma Neaves",
    rating: 5,
    text: "I recently had the team at our house to install some lighting and I couldn\u2019t speak highly enough of them. The place looks fantastic, they arrived on time, cleaned up afterwards and were great to deal with. 11/10 would recommend."
  },
  {
    id: 6,
    author: "Kitty | Sobo3195",
    rating: 5,
    text: "I had major issues with my camera and security system not working and being outdated. Tom and Michael came to the rescue and I couldn\u2019t be happier with their service and professionalism."
  },
  {
    id: 7,
    author: "Suzanne Dwyer",
    rating: 5,
    text: "Excellent communication, punctual and a pleasure to do business with."
  },
  {
    id: 8,
    author: "David Brearley",
    rating: 5,
    text: "Had Tom and Mick install a Sonos sound system at a studio in Hampton. They are both great guys and got the job done without any issues. Super professional and took the time to clearly explain how the whole system worked once installed. Definitely recommended."
  }
];

export const instagramPosts = [
  { id: 1, type: "image", placeholder: true, caption: "Commercial switchboard installation" },
  { id: 2, type: "image", placeholder: true, caption: "CCTV system setup" },
  { id: 3, type: "image", placeholder: true, caption: "Access control installation" },
  { id: 4, type: "image", placeholder: true, caption: "Lighting automation project" },
  { id: 5, type: "image", placeholder: true, caption: "Security system upgrade" },
  { id: 6, type: "image", placeholder: true, caption: "Electrical maintenance" },
  { id: 7, type: "image", placeholder: true, caption: "Commercial project" },
  { id: 8, type: "image", placeholder: true, caption: "Residential security" },
  { id: 9, type: "image", placeholder: true, caption: "Team at work" }
];

export const industries = [
  "Residential",
  "Commercial Offices",
  "Childcare Centres",
  "Dental Practices",
  "Wineries",
  "Retail Stores",
  "Warehouses",
  "Construction Sites",
  "Medical Facilities",
  "Educational Institutions",
  "Hospitality",
  "Manufacturing"
];

export const ctaContent = {
  headline: "Need a Sparky or Security Specialist This Week?",
  description: "Get in touch with our expert team today. Owners respond personally, ensuring fast turnaround and professional installations.",
  features: ["Owners Respond Directly", "Fast Turnaround", "Professional Installs"],
  ctaPrimary: "Get a Quote",
  ctaSecondary: "Call Now"
};

export const footerLinks = {
  quickLinks: [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about-us" },
    { label: "What We Do", href: "/what-we-do" },
    { label: "Industries", href: "/industries" },
    { label: "Our Process", href: "/process" },
    { label: "Contact Us", href: "/contact" },
    { label: "Get a Quote", href: "/get-a-quote" }
  ],
  services: [
    { label: "Security", href: "/what-we-do/security" },
    { label: "Electrical", href: "/what-we-do/electrical" },
    { label: "CCTV", href: "/what-we-do/security#cctv" },
    { label: "Access Control", href: "/what-we-do/security#access-control" }
  ]
};
